import { Link } from '@eventbrite/eds-link';
import { Typography } from '@eventbrite/marmalade';
import { getExperiment, logEvent } from '@eventbrite/statsig';
import React, { useEffect, useState } from 'react';
import {
    LISTING_SEASONAL_AD_BANNER,
    STATSIG_EVENT_NAMES,
} from '../../experimentation';
import { SeasonalBannerProps } from '../../types';
import './SeasonalAdBanner.scss';

export const SeasonalAdBanner = (seasonalProps: SeasonalBannerProps) => {
    const [showSeasonalAdBanner, setSeasonalAdBanner] = useState(false);
    const { title, subtitle, ctaLink, ctaText } = seasonalProps;

    useEffect(() => {
        const variant = getExperiment(
            LISTING_SEASONAL_AD_BANNER.experimentName,
            LISTING_SEASONAL_AD_BANNER.param,
            LISTING_SEASONAL_AD_BANNER.defaultValue,
        );
        setSeasonalAdBanner(variant == true);
    }, []);

    const _handleCtaOnClick = () => {
        logEvent(STATSIG_EVENT_NAMES.LISTING_AD_BANNER_CLICK);
    };

    if (!showSeasonalAdBanner) {
        return null;
    }

    return (
        <section className="seasonal_ad_banner" data-testid={'seasonal-ads'}>
            <div className="seasonal-ad-banner-wrapper">
                <div className="seasonal-ad-banner-container">
                    <Typography
                        variant={'display-md'}
                        align="left"
                        color={'white'}
                    >
                        {title}
                    </Typography>
                    <div className="seasonal_ad_banner__item">
                        <Typography
                            variant={'body-md'}
                            align="left"
                            color={'white'}
                        >
                            {subtitle}
                        </Typography>
                    </div>

                    <div className="seasonal_ad_banner__item seasonal_ad_banner__cta-container">
                        <Link
                            aria-label={ctaText}
                            data-heap-id="seasonal_ad_banner__cta"
                            onClick={_handleCtaOnClick}
                            to={ctaLink}
                            data-spec="seasonal-cta"
                            target="_blank"
                        >
                            <div className="seasonal_ad_banner__cta-text eds-text-bm eds-text-weight--heavy">
                                {ctaText}
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};
